import { Box, Button, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { TableBase } from 'src/components/table/table-base.component';

export const TablePaymentInfo = ({
  setPaymentModal,
  setSelectedPayment,
  paymentsConfig,
  sources,
}) => (
  <Paper
    variant="outlined"
    style={{
      padding: '16px 32px 32px 32px',
      marginBottom: 32,
    }}
    id="payment-sources"
  >
    <Box padding="16px 0 32px 0">
      <Box display="flex">
        <Typography variant="h5">Credit Cards</Typography>
        <Button
          color="primary"
          style={{ marginLeft: 'auto' }}
          variant="contained"
          size="small"
          onClick={() => setPaymentModal(true)}
        >
          Add New
        </Button>
      </Box>
      <TableBase
        rows={sources}
        columns={paymentsConfig}
        scroll
        onRowClick={(row) => {
          setSelectedPayment(row);
          setPaymentModal(true);
        }}
      />
    </Box>
  </Paper>
);
